import { StylesConfig } from 'react-select';
import { getColorValue } from '@shinetools/sunshine';

import { OptionData } from './types';

const grey300 = getColorValue('grey.300');
const grey100 = getColorValue('grey.100');

export const styles: StylesConfig<OptionData> = {
  container: (baseStyles) => ({
    ...baseStyles,
    maxWidth: '360px',
    width: '100%',
  }),
  control: (baseStyles) => ({
    ...baseStyles,
    ':active': {
      borderColor: 'transparent',
    },
    ':focus': {
      borderColor: 'transparent',
    },
    ':hover': {
      borderColor: 'transparent',
    },
    alignItems: 'flex-start',
    borderColor: 'transparent',
    boxShadow: 'none',
    flexDirection: 'column',
    paddingBottom: '4px',
    paddingTop: '4px',
  }),
  group: (baseStyles) => ({
    ...baseStyles,
    ':last-child': {
      borderBottom: 'none',
    },
    borderBottom: `1px solid ${grey300}`,
    marginBottom: '0px',
  }),
  groupHeading: () => ({
    ':hover': {
      backgroundColor: grey100,
    },
    padding: '10px 16px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    borderRadius: 8,
    boxShadow: `0 0 0 1px ${grey300}, 0px 4px 8px 0px rgba(239, 235, 235, 0.45), 0px 4px 16px 0px rgba(239, 235, 235, 0.45)`,
    margin: 0,
    overflow: 'hidden',
    width: '360px',
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    ':active': {
      backgroundColor: grey100,
    },
    ':hover': {
      backgroundColor: grey100,
    },
    backgroundColor:
      state.isSelected || state.isFocused ? grey100 : 'transparent',
    cursor: 'pointer',
    padding: '10px 16px',
    ...(state.isDisabled ? { cursor: 'not-allowed' } : {}),
  }),
};
